// extracted by mini-css-extract-plugin
module.exports = {"hidden":"SheetTitle__hidden--1bK78","sectionTitle":"SheetTitle__sectionTitle--3sYxs","sectionHeader":"SheetTitle__sectionHeader--3xMOA"};